import axios from "axios";
import { ApiKey, liveURL } from "../../const/constants";

const MAIN_URL = `${liveURL}/websitexhibitions`; 
export async function getExhibitions() { 
  try {
    const response = await axios.get(`${MAIN_URL}/getExhibitions`,{
          headers: {
            apikey: ApiKey,
          },
        });
    return response.data;
  } catch (error) {
    console.log("Error fetching exhibitions:", error);
    return { Result: false, Msg: "Error fetching exhibitions" };
  }
}

export async function getExhibitionById(id) { // No token if public
  try {
    const response = await axios.get(`${MAIN_URL}/getExhibition/${id}`,{
          headers: {
            apikey: ApiKey,
          },
        });
    return response.data;
  } catch (error) {
    console.log("Error fetching exhibition by ID:", error);
    return { Result: false, Msg: "Error fetching exhibition" };
  }
}